var Class           = require("Class"),
    $               = require("jquery"),
    Events          = require("Events");

var Widget = Class.extend({

    includes: Events,

    statics: {
        CLASSES: {
            HIDDEN_CLASS: 'hidden'
        }
    },

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this;

        options || (options = {});

        that._hidden = false;

        that._container = $('<div></div>');
        that._container.addClass('omjs-widget');

        if (typeof options.classes == 'string' && options.classes.length > 0) {
            that._container.addClass(options.classes);
        }

        if (typeof options.css == 'object') {
            that._container.css(options.css);
        }

        if ('name' in options) {
            that._name = options.name;
            delete options['name'];
        }

        if (typeof options.translate == 'function') {
            that._translate = options.translate;
            delete options['translate'];
        } else {
            that._translate = function (phrase) {
                return phrase;
            };
        }

        that.setOptions(options);
    },

    /**
     *
     * @return {*|jQuery|HTMLElement|Widget._container}
     */
    getContainer: function() {
        return this._container;
    },


    getName: function(){
        return this._name;
    },

    /**
     *
     */
    show: function(){
        var that = this;
        that.getContainer().removeClass(Widget.CLASSES.HIDDEN_CLASS);
        that._hidden = false;
        that.fire('show');
        return that;
    },

    /**
     *
     */
    hide: function(){
        var that = this;
        that.getContainer().addClass(Widget.CLASSES.HIDDEN_CLASS);
        that._hidden = true;
        that.fire('hide');
        return that;
    },

    /**
     *
     */
    onAdd: function(view){
        return void(0);
    },

    onRemove: function(view){
        return void(0);
    },

    isHidden: function(){
        var that = this;
        return that._hidden;
    },

    translate: function (phrase) {
        var that = this;
        return that._translate(phrase);
    }
});

module.exports = Widget;



//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Widget.js
// module id = 31
// module chunks = 0